var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomepageLocationPin = function SvgHomepageLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.57 18.12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.29 18.12s5.28-9.58 5.28-12.74S8.42 0 5.29 0 0 2.23 0 5.38s5.29 12.74 5.29 12.74m0-15.74c1.79 0 2.9 1.15 2.9 3s-1.11 3-2.9 3-2.9-1.15-2.9-3 1.11-3 2.9-3"
  })));
};
export default SvgHomepageLocationPin;